import Paragraph from "@tiptap/extension-paragraph";

export const PRINTOUT_PARAGRAPH_VARIANTS = ["body1", "body2", "caption", "displayTitle", "largeValue", "detailValue"] as const;

export type PrintoutParagraphVariant = typeof PRINTOUT_PARAGRAPH_VARIANTS[number];

export const DEFAULT_PRINTOUT_PARAGRAPH_VARIANT: PrintoutParagraphVariant = "body1";

export const normalizePrintoutParagraphVariant = (value: unknown): PrintoutParagraphVariant => (
    PRINTOUT_PARAGRAPH_VARIANTS.includes(value as PrintoutParagraphVariant)
        ? value as PrintoutParagraphVariant
        : DEFAULT_PRINTOUT_PARAGRAPH_VARIANT
);

export const PrintoutParagraphNode = Paragraph.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            variant: {
                default: DEFAULT_PRINTOUT_PARAGRAPH_VARIANT,
                parseHTML: (element: HTMLElement) => normalizePrintoutParagraphVariant(
                    element.getAttribute("data-printout-paragraph-variant"),
                ),
                renderHTML: (attributes: Record<string, unknown>) => {
                    const variant = normalizePrintoutParagraphVariant(attributes.variant);

                    return variant === DEFAULT_PRINTOUT_PARAGRAPH_VARIANT
                        ? {}
                        : {"data-printout-paragraph-variant": variant};
                },
            },
        };
    },
});
